import React from "react";
import {
  CalendarDay,
  DayPicker,
  DayPickerProps,
  PropsRange,
  useDayPicker,
} from "react-day-picker";
import { fi } from "date-fns/locale";
import {
  GetBookingCalendarLabel,
  ReservedDate,
} from "../../pages/BookingsPage/bookingsSlice";
import { Link } from "react-router-dom";

interface CustomDayButtonProps {
  day: CalendarDay;
  indexLetter?: string;
  modifiers: Record<string, boolean>;
  reservedDates: { [key: string]: ReservedDate };
  selected: boolean;
  accommodationId: string;
  onIcalClick?: (reservedDate: ReservedDate) => void;
}

const CustomDayButton: React.FC<CustomDayButtonProps> = ({
  day,
  indexLetter = "N",
  modifiers,
  reservedDates,
  selected,
  accommodationId,
  onIcalClick,
  ...buttonProps
}) => {
  const { select } = useDayPicker<PropsRange>();
  const date = day.date;
  let dateKey: string = "";
  dateKey += date.getFullYear().toString() + "-";
  let keyMonth = date.getMonth() + 1;
  dateKey += keyMonth < 10 ? "0" + keyMonth.toString() : keyMonth.toString();
  dateKey += "-";
  dateKey +=
    date.getDate() < 10
      ? "0" + date.getDate().toString()
      : date.getDate().toString();
  //const dateKey = moment(day).format("YYYY-MM-DD");
  //const reserved = this.state.reservedDates;
  const currentReserved = reservedDates ? reservedDates[dateKey] : null;
  const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    // If this day is disabled (by parent), do not trigger date selection
    if (modifiers.disabled) {
      // Allow internal <Link> clicks, but don't propagate to day-picker
      e.stopPropagation();
      return;
    }

    if (select) {
      select(day.date, { selected, ...modifiers }, e);
    }
  };
  const isIcalBooking = currentReserved?.bookingType === 998;

  if (currentReserved && currentReserved.startDay && currentReserved.endDay) {
    return (
      <button
        {...buttonProps}
        className={"rdp-day_button rdp-day_button-reserved position-relative"}
        onClick={handleClick}
      >
        {isIcalBooking ? (
          <span
            className={
              "rdp-day_index rdp-day_index--" + currentReserved.bookingType
            }
            onClick={(e) => {
              e.stopPropagation();
              onIcalClick?.(currentReserved);
            }}
            style={{ cursor: "pointer" }}
          >
            {GetBookingCalendarLabel(currentReserved.bookingType)}
          </span>
        ) : (
          <Link
            to={`/bookings/booking/${currentReserved.bookingId}?accommodationId=${accommodationId}`}
            className={
              "rdp-day_index rdp-day_index--" + currentReserved.bookingType
            }
          >
            {GetBookingCalendarLabel(currentReserved.bookingType)}
          </Link>
        )}
        {day.date.getDate()}
      </button>
    );
  }
  if (currentReserved && currentReserved.startDay) {
    return (
      <button
        {...buttonProps}
        className={
          "rdp-day_button rdp-day_button-reserved rdp-day_button-reserved-start position-relative"
        }
        onClick={handleClick}
      >
        {isIcalBooking ? (
          <span
            className={
              "rdp-day_index rdp-day_index--" + currentReserved.bookingType
            }
            onClick={(e) => {
              e.stopPropagation();
              onIcalClick?.(currentReserved);
            }}
            style={{ cursor: "pointer" }}
          >
            {GetBookingCalendarLabel(currentReserved.bookingType)}
          </span>
        ) : (
          <Link
            to={`/bookings/booking/${currentReserved.bookingId}?accommodationId=${accommodationId}`}
            className={
              "rdp-day_index rdp-day_index--" + currentReserved.bookingType
            }
          >
            {GetBookingCalendarLabel(currentReserved.bookingType)}
          </Link>
        )}
        {day.date.getDate()}
      </button>
    );
  } else if (currentReserved && currentReserved.endDay) {
    return (
      <button
        {...buttonProps}
        className={
          "rdp-day_button rdp-day_button-reserved rdp-day_button-reserved-end position-relative"
        }
        onClick={handleClick}
      >
        {day.date.getDate()}
      </button>
    );
  } else if (currentReserved) {
    return (
      <button
        {...buttonProps}
        className={"rdp-day_button rdp-day_button-reserved position-relative"}
        onClick={handleClick}
      >
        {day.date.getDate()}
      </button>
    );
  } else {
    return (
      <button {...buttonProps} onClick={handleClick}>
        {day.date.getDate()}
      </button>
    );
  }
};
export default CustomDayButton;
